// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './Bar.css'
import { bem } from '../../../../../../../../helpers/bem'
import { themeToClassName } from '../../../../../../../../helpers/themeToClassName'

type Props = {
  width: number,
  isHighlighted: boolean,
  isSlim: boolean
}

type State = {
  isMounted: boolean
}

export class Bar extends Component<Props, State> {
  state = {
    isMounted: false
  }

  componentDidMount () {
    setTimeout(() => {
      requestAnimationFrame(() => {
        this.setState({
          isMounted: true
        })
      })
    }, 80)
  }

  render () {
    const { width, isHighlighted, isSlim } = this.props
    const { isMounted } = this.state
    const { theme, isInteractive } = this.context

    // isInteractive is set through context, and is set to true if
    // the application / component is hydrated on the client
    const transform = isInteractive
      ? getTransform(isMounted ? width : 0)
      : getTransform(width)
    return (
      <div className={bem(styles.bar, isSlim ? 'slim' : null)}>
        <div
          className={bem(
            styles.bar__main,
            themeToClassName(theme),
            isHighlighted ? 'highlighted' : ''
          )}
          style={transform}
        />
      </div>
    )
  }
}

function getTransform (width: number, transitionDelayMs: number = 20): Object {
  // Ensure bars get a certain width
  if (width < 5) width = 5
  const transform = `translateX(-${100 - width}%)`
  return {
    WebkitTransform: transform,
    MozTransform: transform,
    msTransform: transform,
    OTransform: transform,
    transform,
    transitionDelay: '20ms'
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Result/components/ResultList/components/ResultItem/components/Bar/Bar.js